<template>
    <b-card no-body>
        <b-card-header class="pb-50">
            <h5>FILTROS</h5>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col
                    cols="12"
                    md="6"
                    class="mb-2"
                >
                    <label>Método(s) de pago</label>
                    <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple="multiple"
                        v-model="paymentMethodsFilterArray"
                        :options="paymentMethodOptions"
                        class="w-100"
                        @input="inputPaymentMethodsVal()"
                    />
                </b-col>
                <b-col
                    cols="12"
                    md="6"
                    class="mb-2"
                >
                    <label>Tipo(s) de entrega</label>
                    <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple="multiple"
                        v-model="deliveryTypesFilterArray"
                        :options="deliveryTypeOptions"
                        class="w-100"
                        @input="inputDeliveryTypesVal()"
                    />
                </b-col>
                <b-col
                    cols="12"
                    md="6">
                    <label>Rango de fechas de la venta</label>
                    <flat-pickr
                        @on-change="doSomethingOnChange"
                        v-model="rangePicker"
                        class="form-control"
                        :config="config"
                        placeholder="YYYY-MM-DD"
                    />
                </b-col>
                <b-col
                    cols="12"
                    md="6"
                >
                    <label>Estado(s)</label>
                    <v-select
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple="multiple"
                        v-model="saleStatesFilterArray"
                        :options="saleStateOptions"
                        class="w-100"
                        @input="inputSaleStatesVal()"
                    />
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>

    import { BCard, BCardHeader, BCardBody, BRow, BCol } from 'bootstrap-vue';
    import flatPickr from 'vue-flatpickr-component';
    import { Spanish } from 'flatpickr/dist/l10n/es';
    import vSelect from 'vue-select';

    export default {
        components: {
            BRow,
            BCol,
            BCard,
            BCardHeader,
            BCardBody,
            flatPickr,
            vSelect
        },
        data (){
            return {
                config: {
                    mode: 'range',
                    locale: Spanish
                },
                minDate: null,
                maxDate: null,
                rangePicker: null,
                paymentMethodsFilterArray: [],
                deliveryTypesFilterArray: [],
                saleStatesFilterArray: []
            }
        },
        props: {
            paymentMethodsFilter: {
                type: [String, null],
                default: null
            },
            deliveryTypesFilter: {
                type: [String, null],
                default: null
            },
            saleStatesFilter: {
                type: [String, null],
                default: null
            },
            paymentMethodOptions: {
                type: Array,
                required: true
            },
            deliveryTypeOptions: {
                type: Array,
                required: true
            },
            saleStateOptions: {
                type: Array,
                required: true
            }
        },
        methods: {
            doSomethingOnChange (){
                if (typeof this.rangePicker === 'string')
                {
                    let rangeDates = this.rangePicker.split( 'a ');
                    this.minDate = rangeDates[0];
                    this.maxDate = rangeDates[1];

                    let range = this.minDate+this.maxDate;

                    this.$emit('update:rangePickerFilter', range);
                }
            },
            inputPaymentMethodsVal (){
                if (this.paymentMethodsFilterArray){
                    let array = [];
                    this.paymentMethodsFilterArray.map(item => {
                        array.push(item.value);
                    });
                    this.$emit('update:paymentMethodsFilter', array.join(','));
                    return array;
                }
                return null;
            },
            inputDeliveryTypesVal (){
                if (this.deliveryTypesFilterArray){
                    let array = [];
                    this.deliveryTypesFilterArray.map(item => {
                        array.push(item.value);
                    });
                    this.$emit('update:deliveryTypesFilter', array.join(','));
                    return array;
                }
                return null;
            },
            inputSaleStatesVal (){
                if (this.saleStatesFilterArray){
                    let array = [];
                    this.saleStatesFilterArray.map(item => {
                        array.push(item.value);
                    });
                    this.$emit('update:saleStatesFilter', array.join(','));
                    return array;
                }
                return null;
            }
        }
    }

</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-flatpicker.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>